import { useState } from 'react';
import { formatFechaTicket, imprimirTicketCorteDeepLink, LOGO_URL } from '../../utils/ticketBluetooth';

const fmt = (n) => (n || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const TicketCorte = ({ data, onCerrar, onImprimir }) => {
    const [error, setError] = useState(null);

    const {
        folio, fecha, responsable, sucursal,
        efectivoInicial, totalVentas, totalVueltas, totalGastos, totalFinal,
        metodos,
        conosVendidos, conosIniciales, conosTotales, conosFinales,
        tiposConos, evento,
    } = data;

    const handleImprimir = async () => {
        setError(null);
        try {
            imprimirTicketCorteDeepLink(data);
            if (onImprimir) await onImprimir();
            onCerrar();
        } catch (err) {
            setError('No se pudo abrir la app de impresión. Verifica que esté instalada.');
        }
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.container}>
                {/* Preview visual */}
                <div style={styles.ticket}>
                    <div style={{ textAlign: 'center', marginBottom: '0.3rem' }}>
                        <img src={LOGO_URL} alt="Papa Roll" style={{ width: '50%', display: 'inline-block' }} />
                    </div>
                    <div style={styles.subtitulo}>Corte de caja</div>
                    <div style={styles.sep}>{'-'.repeat(32)}</div>

                    <div style={styles.linea}>{formatFechaTicket(fecha)}</div>
                    <div style={styles.linea}>Folio: {folio}</div>
                    <div style={styles.linea}>Responsable: {responsable}</div>
                    <div style={styles.linea}>Sucursal: {sucursal}</div>
                    {evento && <div style={styles.linea}>Evento: {evento}</div>}

                    <div style={styles.sep}>{'-'.repeat(32)}</div>

                    <div style={styles.linea}>
                        Efectivo inicial
                        <span style={{ float: 'right' }}>${fmt(efectivoInicial)}</span>
                    </div>
                    <div style={styles.linea}>
                        Total ventas
                        <span style={{ float: 'right' }}>${fmt(totalVentas)}</span>
                    </div>
                    <div style={styles.linea}>
                        Total v. ambulantes
                        <span style={{ float: 'right' }}>${fmt(totalVueltas)}</span>
                    </div>
                    <div style={styles.linea}>
                        Total gastos
                        <span style={{ float: 'right' }}>-${fmt(totalGastos)}</span>
                    </div>

                    <div style={styles.sep}>{'-'.repeat(32)}</div>

                    <div style={styles.total}>
                        TOTAL FINAL
                        <span style={{ float: 'right' }}>${fmt(totalFinal)}</span>
                    </div>

                    {metodos && metodos.length > 0 && (
                        <>
                            <div style={styles.sep}>{'-'.repeat(32)}</div>
                            <div style={styles.seccion}>Por método</div>
                            {metodos.map((m, i) => (
                                <div key={i}>
                                    <div style={styles.linea}>
                                        {m.nombre}
                                        <span style={{ float: 'right' }}>${fmt(m.neto)}</span>
                                    </div>
                                    {m.totalReal != null && (
                                        <div style={{ ...styles.linea, color: '#777', paddingLeft: '6px' }}>
                                            {m.nombre} real
                                            <span style={{ float: 'right' }}>${fmt(m.totalReal)}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </>
                    )}

                    {tiposConos && tiposConos.length > 0 && (
                        <>
                            <div style={styles.sep}>{'-'.repeat(32)}</div>
                            <div style={styles.seccion}>Tipos de conos</div>
                            {tiposConos.map((t, i) => (
                                <div key={i} style={styles.linea}>
                                    {t.nombre}
                                    <span style={{ float: 'right' }}>{t.vendidos}</span>
                                </div>
                            ))}
                        </>
                    )}

                    <div style={styles.sep}>{'-'.repeat(32)}</div>
                    <div style={styles.seccion}>Conos</div>

                    <div style={styles.linea}>
                        Vendidos
                        <span style={{ float: 'right' }}>{conosVendidos}</span>
                    </div>
                    <div style={styles.linea}>
                        Iniciales
                        <span style={{ float: 'right' }}>{conosIniciales}</span>
                    </div>
                    <div style={styles.linea}>
                        Totales disponibles
                        <span style={{ float: 'right' }}>{conosTotales}</span>
                    </div>
                    <div style={{ ...styles.linea, fontWeight: 'bold' }}>
                        Finales (físico)
                        <span style={{ float: 'right' }}>{conosFinales}</span>
                    </div>

                    <div style={styles.sep}>{'-'.repeat(32)}</div>
                </div>

                {error && (
                    <div style={styles.errorBox}>
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {error}
                    </div>
                )}

                <div style={styles.botones}>
                    <button style={styles.btnImprimir} onClick={handleImprimir}>
                        <i className="fas fa-print me-2"></i>
                        Imprimir
                    </button>
                    <button style={styles.btnCerrar} onClick={onCerrar}>
                        <i className="fas fa-times me-2"></i>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '1rem',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
        maxHeight: '90vh',
        overflowY: 'auto',
    },
    ticket: {
        background: '#fff',
        color: '#111',
        width: '220px',
        padding: '1rem',
        fontFamily: 'monospace',
        fontSize: '11px',
        borderRadius: '8px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
    },
    subtitulo: {
        textAlign: 'center',
        fontSize: '10px',
        color: '#555',
        marginBottom: '0.3rem',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
    },
    sep: {
        color: '#bbb',
        margin: '0.35rem 0',
        overflow: 'hidden',
        fontSize: '10px',
    },
    linea: {
        margin: '0.15rem 0',
        lineHeight: 1.4,
    },
    seccion: {
        fontWeight: 'bold',
        fontSize: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: '#555',
        margin: '0.2rem 0',
    },
    total: {
        fontWeight: 'bold',
        fontSize: '13px',
        margin: '0.3rem 0',
    },
    errorBox: {
        background: 'rgba(229,62,62,0.15)',
        border: '1px solid rgba(229,62,62,0.4)',
        borderRadius: '8px',
        color: '#E53E3E',
        fontSize: '0.82rem',
        padding: '0.65rem 1rem',
        maxWidth: '260px',
        textAlign: 'center',
    },
    botones: {
        display: 'flex',
        gap: '0.75rem',
    },
    btnImprimir: {
        background: '#F5C800',
        color: '#111',
        border: 'none',
        borderRadius: '10px',
        padding: '0.75rem 1.5rem',
        fontWeight: 800,
        fontSize: '1rem',
        cursor: 'pointer',
    },
    btnCerrar: {
        background: 'transparent',
        color: '#888',
        border: '1px solid #444',
        borderRadius: '10px',
        padding: '0.75rem 1.5rem',
        fontWeight: 700,
        fontSize: '1rem',
        cursor: 'pointer',
    },
};

export default TicketCorte;
